import React, { useEffect, useState, useCallback, useMemo, useRef } from "react"
import { AgGridReact } from "ag-grid-react"
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import Modal from "react-modal";
import ModalContent from '../../common/Modal/ModalContent';
import close_modal from '../../assets/ic_close_wh.svg'
import ic_filter from '../../assets/ic_filter.svg'
import { Button } from "../../common/Button/Button";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";

const DynamicProgramTable = ({ programName, partnerData, partnerNames }) => {


  const [selectedOptionsEuProgram, setSelectedOptionsEuProgram] = useState([]);
  const [euProgramModal, setEuProgramModal] = useState(false)
  const [rowData, setRowData] = useState(partnerData)

  const gridRef = useRef()
  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

  const footerRow = {
    programName: "Total",
    first_time_services_count: rowData && rowData.reduce((total, row) => total + row.first_time_services_count, 0),
    engaged_services_count: rowData && rowData.reduce((total, row) => total + row.engaged_services_count, 0),
  };



  const openEuProgramModalisTrue = () => {
    setEuProgramModal(true)
  }

  const openEuProgramModalisFalse = () => {
    setEuProgramModal(false)
  }

  const handleClearClick = () => {
    setSelectedOptionsEuProgram([])
  }

  const columnDefs = [
    {
      headerName: programName,
      field: "sEntryPoint",
      width: 330,
      headerComponentFramework: (params) => {
        return (
            <div style={{ display: "flex",width: '100%', alignItems: "center", whiteSpace: "normal" }}>
                <div style={{ marginRight: "5%" }}>{params.displayName}</div>
                <img
                alt=""
                src={ic_filter}
                height={"25px"}
                width={"25px"}
                className="conv-mr10"
                onClick={() => openEuProgramModalisTrue()}
            />
            </div>
        );
      },
      cellRenderer: (params) => {
        const resourseName = params.value || "Not Provided";
        if (params.data.programName === "Total") {
          return <div style={{ textAlign: "right" }}>Total</div>;
        } else {
          return resourseName;
        }
      },
    },
    {
      headerName: "First Time user Count",
      field: "first_time_services_count",
      flex: 1,
      sortable: true,
      pinnedBottomRowCellRenderer: "agGroupCellRenderer",
      cellStyle: { textAlign: "right" }
    },
    {
      headerName: "Engaged user Count",
      field: "engaged_services_count",
      flex: 1,
      sortable: true,
      pinnedBottomRowCellRenderer: "agGroupCellRenderer",
      cellStyle: { textAlign: "right" }
    },
  ];

  const handleEuProgramSelect = (selected) => {
    setSelectedOptionsEuProgram(selected)
  }

  const handleEuProgramFilterSearchClick = () => {
    const filteredPartnerData = partnerData.filter((partner) =>
      selectedOptionsEuProgram.some((option) => option.value === partner.sEntryPoint)
    );
    if (selectedOptionsEuProgram.length > 0) {
      setRowData(filteredPartnerData)
      openEuProgramModalisFalse()
    } else {
      setRowData(partnerData)
      openEuProgramModalisFalse()
    }
  }

  const gridOptions = useMemo(() => ({
    suppressScrollOnNewData: true,
  }), []);

  return (
    <div style={{
      height: "50vh",
    }}>
      <div style={{ height: "100%", boxSizing: "border-box" }}>
        <div style={gridStyle} className="ag-theme-material">
          <AgGridReact ref={gridRef}
            rowData={rowData}
            columnDefs={columnDefs}
            pinnedBottomRowData={[footerRow]}
            gridOptions={gridOptions}
            overlayNoRowsTemplate={
              '<span class="ag-overlay-loading-center">loading...</span>'
            }
            rowClassRules={{
              'total-row': 'data.programName === "Total"'
            }}
          >
          </AgGridReact>
        </div>
      </div>
      <Modal isOpen={euProgramModal}>
        <ModalContent className="EngagedDashboard-filter-modal">
          <div className="modal-header">
            <span className="modal-title">Filter</span>
            <img
              alt="close"
              id="Close"
              src={close_modal}
              className="close modal-close"
              onClick={openEuProgramModalisFalse}
            />
          </div>

          <div className="modal-body">
            <br />
            <div className="row">
              <div className="col-8 spled-container">
                <div className="width-100">
                  <ReactMultiSelectCheckboxes
                    options={partnerNames.map((partner) => ({
                      label: partner,
                      value: partner,
                    }))}
                    // placeholder="Select partners"
                    placeholderButtonLabel="Select Program"
                    value={selectedOptionsEuProgram}
                    onChange={handleEuProgramSelect}
                  />
                </div>
              </div>
              <div className="col-4 spled-container">
                <div className="width-100">
                  <Button className="esp-inline-button" onClick={handleClearClick}>Clear</Button>
                </div>
              </div>
            </div>
            <br />
            <div className='row d-flex justify-content-center align-items-center'>
              <div className='col-4'></div>
              <div className="col-4">
                <Button className="esp-inline-button" onClick={handleEuProgramFilterSearchClick}>Search</Button>
              </div>
              <div className='col-4'></div>
              {/* <div className="col-4"></div> */}
            </div>

          </div>
        </ModalContent>
      </Modal>
    </div>
  )
}

export default DynamicProgramTable
